import React from "react";
import { IInitializationService } from "../services/initialization/types";
import BoxWidgetView from "./boxWidgetView";
import { Container, interfaces } from "inversify";
import createContainer from "../di.config";

import "reflect-metadata";
import ".";
import RootViewModel from "../viewModels/rootViewModel";

export type ContainerWidgetInitializer = (container: Container) => Promise<RootViewModel>;

async function initContainer(
  init: ContainerWidgetInitializer,
  initService: interfaces.ServiceIdentifier<IInitializationService>
) {
  const container = createContainer();

  const initializationService = container.get<IInitializationService>(initService);
  if (!initializationService.isInitialized) {
    const defaultLanguage = (document.documentElement.lang || "cs").split("-")[0];
    await initializationService.initialize(defaultLanguage === "en" ? "en-GB" : defaultLanguage);
  }

  return await init(container);
}

export default function makeWidget(
  identifier: string,
  init: ContainerWidgetInitializer,
  initializationService: interfaces.ServiceIdentifier<IInitializationService>
) {
  const fullInit = async () => initContainer(init, initializationService);
  return () => <BoxWidgetView init={fullInit} identifier={identifier} />;
}
